import PropTypes from "prop-types";
import { Loading, VirtualTable } from "../";

export default function LoadTable({
  data,
  loading,
  error,
  title,
  TypeOfPortal,
  ledgerTable,
  selectedRows,
  multiSelect,
  dragDrop,
  settings,
  options,
  select = true,
  Tab = "",
  SelectCheckbox,
  colAddition = [],
  TableHeaders = [],
  InitialGrouping = false,
  GroupValues = [],
  ModalTable=false,
  onExportExcel=undefined,
  resetFiltersOnUnmount=false,
  onDoubleClick=undefined,
}) {
  // console.log(data, loading, error, title, "KKKKKKKKKKKK");
  return (
    <>
      {loading ? (
        <Loading />
      ) : error ? (
        <p className="DataNotAvailable">{error.message}</p>
      ) : data?.length === 0 ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {/* {title !== "New References" &&
            title !== "L.R.List For Bill" &&
            title !== "New Companies" &&
            title !== "New Branches" &&
            title !== "LRTable" &&
            title !== "Selected LR" && <DragDiv data={data} />} */}

          <VirtualTable
            title={title}
            TypeOfPortal={TypeOfPortal}
            data={data}
            ledgerTable={ledgerTable}
            selectedRows={selectedRows}
            multiSelect={multiSelect}
            dragDrop={dragDrop}
            settings={settings}
            options={options}
            select={select}
            tab={Tab}
            SelectCheckbox={SelectCheckbox}
            colAddition={colAddition}
            TableHeaders={TableHeaders}
            InitialGrouping={InitialGrouping}
            GroupValues={GroupValues}
            ModalTable={ModalTable}
            onExportExcel={onExportExcel}
            resetFiltersOnUnmount={resetFiltersOnUnmount}
            onDoubleClick={onDoubleClick}
          />
        </>
      )}
    </>
  );
}

LoadTable.propTypes = {
  data: PropTypes.array,
  TableHeaders: PropTypes.array,
  Loading: PropTypes.any,
  title: PropTypes.string.isRequired,
  ledgerTable: PropTypes.string,
  selectedRows: PropTypes.array,
  multiSelect: PropTypes.bool,
  TypeOfPortal: PropTypes.string,
  dragDrop: PropTypes.any,
  settings: PropTypes.bool,
  options: PropTypes.bool,
  SelectCheckbox: PropTypes.bool,
};
// Set Default Props
LoadTable.defaultProps = {
  multiSelect: true,
  selectedRows: [],
  ledgerTable: "",
  TypeOfPortal: "",
  dragDrop: true,
  settings: true,
  options: true,
  SelectCheckbox: true,
};
